import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { IApiResponse } from "../../../../utils/types/api-response";
import {
    updateClientForm,
    createClientForm,
    uploadFormDocument,
    deleteClientForm,
    deleteFormDocument,
} from "../../services/client-forms.services";
import {
    IAddClientFormPayload,
    IClientForm,
    IUpdateClientFormPayload,
} from "../../types/client-forms.types";

export function useUpdateClientForm() {
    return useMutation<
        IApiResponse<IClientForm>,
        AxiosError<IApiResponse<IClientForm>>,
        { clientId: string; formId: string; data: IUpdateClientFormPayload }
    >({
        mutationKey: ["update-client-form"],
        mutationFn: ({ clientId, formId, data }) =>
            updateClientForm(clientId, formId, data),
    });
}

export function useCreateClientForm() {
    return useMutation<
        IApiResponse<IClientForm>,
        AxiosError<IApiResponse<IClientForm>>,
        {
            clientId: string;
            data: IAddClientFormPayload;
        }
    >({
        mutationKey: ["create-client-form"],
        mutationFn: ({ clientId, data }) => createClientForm(clientId, data),
    });
}

export function useUploadFormDocument() {
    return useMutation<
        IApiResponse<IClientForm>,
        AxiosError<IApiResponse<IClientForm>>,
        { clientId: string; formId: string; formData: FormData }
    >({
        mutationKey: ["upload-form-document"],
        mutationFn: ({ clientId, formId, formData }) =>
            uploadFormDocument(clientId, formId, formData),
    });
}

export function useDeleteClientForm() {
    return useMutation<
        IApiResponse<null>,
        AxiosError<IApiResponse<null>>,
        { clientId: string; formId: string }
    >({
        mutationKey: ["delete-client-form"],
        mutationFn: ({ clientId, formId }) =>
            deleteClientForm(clientId, formId),
    });
}

export function useDeleteFormDocument() {
    return useMutation<
        IApiResponse<IClientForm>,
        AxiosError<IApiResponse<IClientForm>>,
        { clientId: string; formId: string; documentId: string }
    >({
        mutationKey: ["delete-form-document"],
        mutationFn: ({ clientId, formId, documentId }) =>
            deleteFormDocument(clientId, formId, documentId),
    });
}
